import { GroupWithLabels } from "./groupWithLabels";
import { WithLabel } from "./withLabel";

export const CheckboxCompositions = {
    WithLabel,
    GroupWithLabels,
};

export type { WithLabelProps as CheckboxWithLabelProps } from "./withLabel";
export type { GroupWithLabelsProps as CheckboxGroupWithLabelsProps, CheckboxOption } from "./groupWithLabels";
